import './GamingHabits.scss';

import * as Yup from 'yup';

import { Button, Form } from 'react-bootstrap';
import { FIRST_QUESTION_ID, PROFIL_TABS } from '../../utils/constants';
import {
  checkUserStatus,
  getCandidateGamingHabits,
  putCandidateGamingHabits,
  selectGamingHabits,
  selectIsFetchingGamingHabits,
  selectUserStatus
} from '../../ducks/entities';
import {
  scrollToBannerBottom,
  scrollToTop,
  setTitle
} from '../../utils/generic';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ControllerExperience from '../../components/ControllerExperience/ControllerExperience';
import DifficultyLevel from '../../components/DifficultyLevel/DifficultyLevel';
import DlcContents from '../../components/DlcContents/DlcContents';
import { Formik } from 'formik';
import FpsControllerExperience from '../../components/FpsControllerExperience/FpsControllerExperience';
import GamingGenres from '../../components/GamingGenres/GamingGenres';
import { GamingHabit } from '../../models/candidate';
import LoaderComponent from '../../components/Loader/LoaderComponents';
import Platforms from '../../components/Platforms/Platforms';
import ProfileSteps from '../../components/ProfileSteps/ProfileSteps';
import PvESocialHabits from '../../components/PvESocialHabits/PvESocialHabits';
import PvPSocialHabits from '../../components/PvPSocialHabits/PvPSocialHabits';
import ScrollToFieldError from '../../components/ScrollToFieldError/ScrollToFieldError';
import WeeklyPlaytime from '../../components/WeeklyPlaytime/WeeklyPlaytime';
import iconGamepad from '../../assets/images/ubisoft-playtest-profile-icon-gamepad-black.webp';
import iconHeadphones from '../../assets/images/ubisoft-playtest-profile-icon-headphone-black.webp';
import imageStep from '../../assets/images/ubisoft-playtest-profile-mobile-steps-3-4.webp';
import messages from './messagesGamingHabits';
import profilMessage from './messages';
import { selectAuth } from '../../ducks/auth';
import siteMessages from '../root/siteMessages';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';

interface Props {
  setIsFieldModified(value: boolean): void;
}

const SECTION_NAME = 'gamingHabits';

const GamingHabits = (props: Props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);
  const gamingHabits = useSelector(selectGamingHabits);
  const isFetchingGamingHabits = useSelector(selectIsFetchingGamingHabits);
  const [next, setNext] = useState(true);
  const navigate = useNavigate();
  const [schema, setSchema] = useState<any>();
  const [controllerExperienceSchema, setControllerExperienceSchema] =
    useState<any>();
  const [fpsControllerExperienceSchema, setFpsControllerExperienceSchema] =
    useState<any>();
  const [platformsSchema, setPlatformsSchema] = useState<any>();
  const [gamingGenresSchema, setGamingGenresSchema] = useState<any>();
  const [weeklyPlaytimeSchema, setWeeklyPlaytimeSchema] = useState<any>();
  const [difficultyLevelSchema, setDifficultyLevelSchema] = useState<any>();
  const [dlcContentsSchema, setDlcContentsSchema] = useState<any>();
  const [PvESocialHabitsSchema, setPvESocialHabitsSchema] = useState<any>();
  const [PvPSocialHabitsSchema, setPvPSocialHabitsSchema] = useState<any>();
  const userStatus = useSelector(selectUserStatus);
  const location = useLocation();
  const [validateOnChange, setValidateOnChange] = useState(false);

  useEffect(() => {
    setTitle(intl.formatMessage({ ...profilMessage.gaminghabits }));
  }, []);

  useEffect(() => {
    dispatch(getCandidateGamingHabits());
  }, [auth.userId]);

  useEffect(() => {
    setSchema({
      ...controllerExperienceSchema,
      ...fpsControllerExperienceSchema,
      ...platformsSchema,
      ...gamingGenresSchema,
      ...weeklyPlaytimeSchema,
      ...difficultyLevelSchema,
      ...dlcContentsSchema,
      ...PvESocialHabitsSchema,
      ...PvPSocialHabitsSchema
    });
    location.state?.prevRoute ? scrollToBannerBottom() : scrollToTop();
  }, [
    controllerExperienceSchema,
    fpsControllerExperienceSchema,
    platformsSchema,
    gamingGenresSchema,
    weeklyPlaytimeSchema,
    difficultyLevelSchema,
    dlcContentsSchema,
    PvESocialHabitsSchema,
    PvPSocialHabitsSchema
  ]);

  const onSubmit = async (values: GamingHabit, { setSubmitting }: any) => {
    setSubmitting(true);
    props.setIsFieldModified(false);
    await (dispatch(putCandidateGamingHabits(values)) as any)
      .then(() => {
        toast.success(
          intl.formatMessage({ ...siteMessages.updateProfileSuccess })
        );
        setSubmitting(false);
        dispatch(checkUserStatus());
        if (next) {
          const index = Object.keys(userStatus).findIndex(
            (k) => !(userStatus as any)[k] && k !== SECTION_NAME
          );
          navigate(
            location.pathname.replace(
              'gaminghabits',
              PROFIL_TABS[index].pathname
            ),
            { state: { prevRoute: location.pathname }, replace: true }
          );
        }
      })
      .catch(() => {
        props.setIsFieldModified(true);
        toast.error(intl.formatMessage({ ...siteMessages.updateProfileFail }));
      });
  };

  const onSetField = (
    field: string,
    value: any,
    setFieldValue: any,
    shouldValidate?: boolean | undefined
  ) => {
    props.setIsFieldModified(true);
    setFieldValue(field, value, shouldValidate);
  };

  return (
    <div className="gaming-habits">
      <div className="required-field">
        <p>{intl.formatMessage({ ...profilMessage.fieldRequired })}</p>
      </div>
      {!isFetchingGamingHabits && gamingHabits ? (
        <Formik
          initialValues={gamingHabits}
          validationSchema={Yup.object().shape(schema)}
          onSubmit={onSubmit}
          validateOnChange={validateOnChange}
        >
          {({ values, errors, handleSubmit, isSubmitting, setFieldValue }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <ScrollToFieldError />
              <div className="controller-experience">
                <div className="header" id={FIRST_QUESTION_ID}>
                  <img src={iconGamepad} alt="" className="mt-n1" />
                  <h3>
                    {intl.formatMessage({
                      ...messages.headerControllerExperience
                    })}
                  </h3>
                </div>
                <div className="content">
                  <ControllerExperience
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) =>
                      setControllerExperienceSchema(schema)
                    }
                  />
                  <FpsControllerExperience
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) =>
                      setFpsControllerExperienceSchema(schema)
                    }
                  />
                  <Platforms
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) => setPlatformsSchema(schema)}
                  />
                </div>
              </div>
              <div className="gaming-experience">
                <div className="header">
                  <img src={iconHeadphones} alt="" className="mt-n1" />
                  <h3>
                    {intl.formatMessage({ ...messages.headerGamingExperience })}
                  </h3>
                </div>
                <div className="content">
                  <h4>{intl.formatMessage({ ...messages.personal })}</h4>
                  <GamingGenres
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) => setGamingGenresSchema(schema)}
                  />
                  <WeeklyPlaytime
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) => setWeeklyPlaytimeSchema(schema)}
                  />
                  <DifficultyLevel
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) => setDifficultyLevelSchema(schema)}
                  />
                  <DlcContents
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) => setDlcContentsSchema(schema)}
                  />
                  <h4>{intl.formatMessage({ ...messages.multiplayer })}</h4>
                  <PvESocialHabits
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) => setPvESocialHabitsSchema(schema)}
                  />
                  <PvPSocialHabits
                    values={values}
                    errors={errors}
                    setFieldValue={(
                      field: string,
                      value: any,
                      shouldValidate?: boolean | undefined
                    ) =>
                      onSetField(field, value, setFieldValue, shouldValidate)
                    }
                    updateSchema={(schema) => setPvPSocialHabitsSchema(schema)}
                  />
                </div>
              </div>
              <div className="btns-save">
                <Button
                  variant="primary"
                  disabled={isSubmitting}
                  onClick={() => {
                    !Object.keys(userStatus).find(
                      (k) => !(userStatus as any)[k] && k !== SECTION_NAME
                    )
                      ? setNext(false)
                      : setNext(true);
                    setValidateOnChange(true);
                    handleSubmit();
                  }}
                >
                  <LoaderComponent
                    isLoading={isSubmitting}
                    className="lds-small"
                  >
                    {!Object.keys(userStatus).find(
                      (k) => !(userStatus as any)[k] && k !== SECTION_NAME
                    )
                      ? intl.formatMessage({ ...siteMessages.save })
                      : intl.formatMessage({ ...siteMessages.saveAndNext })}
                  </LoaderComponent>
                </Button>
              </div>
              <ProfileSteps step={3} steps={4} image={imageStep} />
            </Form>
          )}
        </Formik>
      ) : (
        <div className="loading">
          {[...Array(9).keys()].map((i) => (
            <p key={`gamingHabits-${i}`} />
          ))}
        </div>
      )}
    </div>
  );
};

export default GamingHabits;
